import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface StatusBarProps {
  templateName: string;
}

const StatusBar: React.FC<StatusBarProps> = ({ templateName }) => {
  return (
    <div className="flex items-center gap-2 px-6 py-2 bg-brand-50 border-t border-brand-100">
      <CheckCircleIcon className="w-4 h-4 text-brand-600" />
      <span className="text-xs text-brand-700">
        当前模板：<strong>{templateName}</strong> · 预览效果即最终导出效果 · 点击「导出下载」获取文件
      </span>
    </div>
  );
};

export default StatusBar;
